























































import Component from 'vue-class-component';
import { AxiosResponse } from 'axios';
import DetailRow from '@/common/component/DetailRow.vue';
import { dataLoggerApi } from '@/context/data_logger/api/DataLoggerApi';
import ConfigurationShowContainer
  from '@/context/configuration/container/ConfigurationShowContainer.vue';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';
import DataLoggerAutcomplete from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import { Watch } from 'vue-property-decorator';
import { notNullOrUndefined } from '@/utility/functions';
import { ConfigurationOverviewModel } from '@/context/data_logger/model/ConfigurationOverviewModel';
import Vue from 'vue';

@Component({
  components: {
    DataLoggerAutcomplete,
    ProgressSpinnerWrapper,
    ConfigurationShowContainer,
    DetailRow
  }
})
export default class ConfigurationOverviewContainer extends Vue {
  dataLogger?: number | null = null;
  model?: ConfigurationOverviewModel | null = null;
  headers = [
    { text: "Obis", value: "desc" },
    { text: "Numer rejestru", value: "reg" },
    { text: "Identyfikator sensora", value: "sensorId" },
    { text: "Pomiar", value: "val" },
    { text: "Jednostka", value: "unit" }
  ];

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await dataLoggerApi.configurationOverview(id);
    this.model = response?.data;
    console.log(this.model);
  }
  @Watch("dataLogger")
  dataLoggerWatchHandle(): void {
    if (notNullOrUndefined(this.dataLogger)) {
      this.fetch(this.dataLogger as number);
    }
  }
}
